import { render, staticRenderFns } from "./InternsFormPage.vue?vue&type=template&id=035276d8&"
import script from "./InternsFormPage.vue?vue&type=script&lang=js&"
export * from "./InternsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports